const BREAKPOINTS = {
  huge: '1440px',
  large: '1170px',
  desk: '1025px',
  medium: '768px',
  small: '450px',
};

export default BREAKPOINTS;
